import { Link } from '@xometry/xometry_loft';
import _ from 'lodash';
import {
  DefaultShippingAddressIndicator,
  ShippingAddressPanel,
  shippingAddressEdit,
  shippingAddressText,
} from '../ShippingAddress.styles';
import countryListUtil from '@xometry/npm_package_country_list';
import { entityTypeEnum, userRoleEnum } from '../types';

const DisplayShippingAddress = (props) => {
  const { onEditClick, address, index, entityType, userRole = null } = props;

  return (
    <ShippingAddressPanel key={`dsa-${index}`} kind="primary">
      <DefaultShippingAddressIndicator>
        {address?.defaultIndicator ? 'Default' : ' '}
      </DefaultShippingAddressIndicator>
      {(entityType == entityTypeEnum.user ||
        (userRole && userRole !== userRoleEnum.contributor)) && (
        <div css={shippingAddressEdit}>
          <Link onClick={() => onEditClick(index)} data-shipping-index={index}>
            Edit
          </Link>
        </div>
      )}
      <div css={shippingAddressText}>
        <div className="pii-encrypt">{address?.name}</div>
        <div className="pii-encrypt">{address?.street1}</div>
        {address?.street2 && address?.street2 !== '' && (
          <div className="pii-encrypt">{address.street2}</div>
        )}
        <div className="pii-encrypt">
          {_.startCase(_.toLower(address?.city))},{' '}
          {address?.state || address?.province} {address?.zipcode}
        </div>
        <div className="pii-encrypt">
          {entityType === entityTypeEnum.user
            ? address?.country
            : countryListUtil.getLabel(address?.countryCode)}
        </div>
        <div className="pii-encrypt"> {address?.phoneNumber} </div>
        <div className="pii-encrypt"> {address?.emailAddress} </div>
      </div>
    </ShippingAddressPanel>
  );
};

export default DisplayShippingAddress;
